// extracted by mini-css-extract-plugin
export default {"root":"BookingNoteDisplay_root__K3odX","label":"BookingNoteDisplay_label__2mmh5","note":"BookingNoteDisplay_note__izsbh"};